import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';
import EFTUV from '@/components/UI/svg/river2/Icon/EFTUV';

const { EFPic } = createEFPic('/media/river2/h5/');
export default function E2() {
    const { useEffect, useLang, useRef, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('productriver2.river2.details');

    return (
        <div className={`${css.E2} river2_detials_E2`}>
            <div className="content">
                <p className="title">{t('secE2_title')}</p>
                <p className="desc">
                    {t.rich('secE2_desc', {
                        h: (h: string) => <span className="h">{h}</span>,
                    })}
                </p>
                <div className="img-box">
                    <EFPic
                        name={['E2.jpg', 'E2.jpg']}
                        // layout="fill"
                        className="fullImgs"
                        alt={t('secE2_title')}
                        aria-label={t('secE2_title')}
                    />
                    <div className="img-icon">
                        <EFTUV />
                    </div>
                </div>
            </div>
        </div>
    );
}
